import { inject } from 'tsyringe'
import { VueI18n } from '~/utils/nuxt3-migration'
import { containerScoped } from '~/decorators/dependency-container'
import { SnackbarOptions, SnackbarVariant } from '~/models/app/snackbar'
import { StoreWithRootState } from '~/store/types'
import { SNACKBAR_NS } from '~/store/modules/shared/snackbar/state'
import {
  storeToken,
  vueI18nToken
} from '~/constants/dependency-injection/tokens'
import { LocaleMessage } from 'vue-i18n'

@containerScoped()
/**
 *
 * @deprecated Use the useSnackbar composable instead
 */
export default class SnackbarService {
  constructor(
    @inject(vueI18nToken) private i18n: VueI18n,
    @inject(storeToken) private store: StoreWithRootState
  ) {}

  show(message: string | LocaleMessage, options: SnackbarOptions = {}) {
    this.store.dispatch(`${SNACKBAR_NS}/show`, {
      message,
      options
    })
  }

  success(text: string | LocaleMessage, options?: any) {
    this.show(text, this.generateOptions('success', options))
  }

  savedChanges() {
    this.success(this.i18n.t('success_saved_changes') as string, {
      time: 1600
    })
  }

  saved() {
    this.success(this.i18n.t('saved::verb') as string, {
      time: 1600
    })
  }

  error(text: string | LocaleMessage | Error, options?: any) {
    this.show(
      text instanceof Error ? text.message : text,
      this.generateOptions('danger', options)
    )
  }

  info(text: string | LocaleMessage, options?: any) {
    this.show(text, this.generateOptions('info', options))
  }

  private generateOptions(
    variant: SnackbarVariant,
    options?: any
  ): SnackbarOptions {
    return {
      variant,
      action: options && options.action,
      classes: (options && options.classes) || [],
      timeout: options && options.time
    }
  }
}
